export default __webpack_public_path__ + "static/media/vk_png.66f471e5.png";